import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-btn-loading',
  templateUrl: './btn-loading.component.html',
  styleUrls: ['./btn-loading.component.scss']
})
export class BtnLoadingComponent implements OnInit {
  @Input() loading: boolean;
  @Input() btnClass: string;
  @Input() loadingText = 'Por favor espere...';
  @Input() type: 'button' | 'submit' = 'submit';

  constructor() { }

  ngOnInit() {
  }

}
